import _ from 'lodash';

import { SpaceBetweenWrapper } from './CheckboxFilterTree.styles';
import { LabelComponent } from './model';

export const ResponsiveLabel: LabelComponent = ({ title, count }) => (
    <SpaceBetweenWrapper>
        <span>{title}</span>
        <span>{count}</span>
    </SpaceBetweenWrapper>
);

export const TextLabel: LabelComponent = ({ title, count }) => (
    <>
        {title}&ensp;{_.isNumber(count) && <>({count})</>}
    </>
);
